import { BackendError, Service } from '@genial/services';
import { BasketEnumsBasketOrderStatusEnum } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { addAuthorizationHeader } from '../../../pages/BatchTicketInvestLink/Constants';
import { CustomerBasketOffersDataResponseProps } from '../../../pages/BatchTicketInvestLink/utils/types';
import { blankMetaResponse } from '../../../utils/blankMetaResponse';
import { screenName } from '../constants';
import {
  normalizeCustomerBasketOffersCoe,
  normalizeCustomerBasketOffersEquity,
  normalizeCustomerBasketOffersFixedIncome,
  normalizeCustomerBasketOffersFund,
  normalizeCustomerBasketOffersTreasury,
  normalizeGeneralData,
} from '../normalize';

export const customersBasketOffersQuery = selectorFamily<
  CustomerBasketOffersDataResponseProps | null | undefined,
  {
    basketCustomerId: string;
    basketOrderStatus: BasketEnumsBasketOrderStatusEnum[];
    jwtToken?: string;
  }
>({
  key: 'customersBasketOffersQuery',
  get: ({ basketCustomerId, basketOrderStatus, jwtToken }) => {
    return async () => {
      try {
        const params = {
          basketCustomerId,
          screenName,
          basketOrderStatus,
        };

        const { data } = await Service.Basket.V1.getCustomerOrderByBasketCustomerIdFilter(
          params,
          addAuthorizationHeader(jwtToken)
        );

        const normalizedData = data.basketCustomerOrder.customerOffers || [];

        const fixedIncome = normalizeCustomerBasketOffersFixedIncome(normalizedData);
        const fund = normalizeCustomerBasketOffersFund(normalizedData);
        const coe = normalizeCustomerBasketOffersCoe(normalizedData);
        const equity = normalizeCustomerBasketOffersEquity(normalizedData);
        const treasury = normalizeCustomerBasketOffersTreasury(normalizedData);

        const normalizeObject = [...fixedIncome, ...fund, ...coe, ...equity, ...treasury];

        const responseData = normalizeGeneralData({ data, offers: normalizeObject as never });

        return responseData as unknown as CustomerBasketOffersDataResponseProps;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return {
            data: [],
            meta: blankMetaResponse(),
          } as unknown as CustomerBasketOffersDataResponseProps;
        }

        throw error;
      }
    };
  },
});
